module.exports = __webpack_public_path__ + "static/img/106.b7aa07d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/106.jpg
// module id = UFPC
// module chunks = 2